import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";

const User_common = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDocument, setShowDocument] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const navigate = useNavigate();
  const statusEnum = ["In-Progress", "Submitted", "Rejected", "Completed"];

  const [licenseData, setLicenseData] = useState({
    application_type: "",
    kisanpointtype: "",
    fullName: "",
    email: "",
    address: "",
    state: "",
    pincode: "",
    mobileNumber: "",
    dateOfBirth: "",
    gatNumber: "",
    khatanumber: "",
    district: "",
    tehsil: "",
    village: "",
    rejectedNote: "",
    submitNote: "",
    completedNote: "",
    Status: "In-Progress",
    statusHistory: "",
  });

  useEffect(() => {
    const fetchLicenseData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://api.makeeasydocuments.com/api/commonForm/getbyidcommon-form/${id}`
        );
        const data = response.data;
        setLicenseData(data);
        console.log("fetched data", data);
        setIsEditable(data.Status === "Rejected");
      } catch (err) {
        setError("Error fetching license data");
        showCustomToast("Error fetching data", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchLicenseData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLicenseData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    // Create the update data object
    const updateData = {
      ...licenseData,
      Status: "In-Progress", // Set status to In-Progress
    };

    console.log("licenseData after update:", licenseData);

    try {
      const response = await axios.put(
        `https://api.makeeasydocuments.com/api/commonForm/updatecommon-form/${id}`,
        updateData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      showCustomToast("Form updated successfully", "success");
      setLicenseData(response.data.commonForm);
      console.log("setLicenData", response.data.commonForm);
      setIsEditable(false);
      console.log("updated data", response);
      setTimeout(() => {
        navigate("/dashboard/my_application");
      }, 4001);
    } catch (error) {
      console.error("Update error:", error);
      showCustomToast(
        error.response?.data?.message || "Failed to update form",
        "error"
      );
    }
  };

  const renderImage = (imageData) => {
    try {
      // Check if all required properties exist and are valid
      if (
        imageData &&
        imageData.contentType &&
        imageData.data &&
        imageData.data.data &&
        Array.isArray(imageData.data.data)
      ) {
        const byteArray = new Uint8Array(imageData.data.data);
        const base64String = btoa(
          Array.from(byteArray)
            .map((byte) => String.fromCharCode(byte))
            .join("")
        );
        return `data:${imageData.contentType};base64,${base64String}`;
      }
      console.log("Invalid image data:", imageData);
      return null;
    } catch (error) {
      console.error("Error rendering image:", error);
      return null;
    }
  };
  const DocumentPreviewModal = ({ document, onClose }) => {
    if (!document) return null;

    // Check if document is a string (URL) or an object
    const documentUrl = typeof document === "string" ? document : null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full">
          <h2>Download The Documents From Here...</h2>

          {documentUrl && (
            <div className="my-4">
              <img
                src={documentUrl}
                className="max-w-full max-h-96 mx-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = ""; // Placeholder for failed image load
                  // e.target.alt = "Unable to preview document";
                }}
              />
            </div>
          )}

          <div className="mt-4 flex justify-between">
            <button
              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
              onClick={onClose}
            >
              Close
            </button>
            {documentUrl && (
              <a
                href={documentUrl}
                download
                className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
              >
                Download
              </a>
            )}
          </div>
        </div>
      </div>
    );
  };
  const DownloadableDocuments = () => {
    console.log("License Data Documents:", licenseData.documents); // Debug log
    if (!licenseData.documents) return null; // Ensure documents is defined

    const { receipt, finisheddoc } = licenseData.documents;

    const status = licenseData.Status;

    return (
      <div className="col-span-3 bg-white shadow-md p-6 rounded-lg mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Downloadable Documents
        </h2>
        {(status === "Submitted" || status === "Completed") && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {status === "Submitted" || status === "Completed" ? (
              <div className="border p-4 rounded-lg text-center bg-gray-50">
                <h3 className="font-semibold mb-2">Receipt</h3>
                <button
                  className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                  onClick={() => {
                    const imageUrl = renderImage(receipt);
                    setShowDocument(imageUrl);
                  }}
                >
                  View Receipt
                </button>
              </div>
            ) : (
              <div className="hidden sm:block"></div> // Placeholder to maintain layout
            )}
            {status === "Completed" && finisheddoc ? (
              <div className="border p-4 rounded-lg text-center bg-gray-50">
                <h3 className="font-semibold mb-2">Finished Document</h3>
                <button
                  className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                  onClick={() => setShowDocument(renderImage(finisheddoc))}
                >
                  View Document
                </button>
              </div>
            ) : (
              <div className="hidden sm:block"></div> // Placeholder to maintain layout
            )}
          </div>
        )}
      </div>
    );
  };

  const InputField = ({
    label,
    name,
    value,
    type = "text",
    disabled = !isEditable,
  }) => (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}:
      </label>
      <input
        type={type}
        name={name}
        value={value || ""}
        onChange={handleInputChange}
        disabled={disabled}
        className={`w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:border-transparent
          ${disabled ? "bg-gray-50 text-gray-500" : "bg-white"}
          ${isEditable ? "hover:border-blue-500 transition-colors" : ""}
        `}
      />
    </div>
  );

  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );

  if (error)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="bg-red-50 text-red-600 px-4 py-3 rounded-lg shadow">
          {error}
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-1 pt-4">
            <h2 className="text-2xl font-bold text-white">{licenseData.application_type}</h2>
            <p className="text-white mt-1">Status: {licenseData?.Status || 'Loading...'}</p>
          </div >
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-0">
            {/* for display note accroding to status  */}
            {licenseData.Status === "Rejected" && (
              <div className="bg-gradient-to-r from-blue-600 to-blue-700">
                <strong className="text-white mt-1">
                  Rejected Note:
                </strong>
                <span className="text-white mt-1">
                  {licenseData.Status ? licenseData.rejectedNote : "N/A"}
                </span>
              </div>
            )}

            {/* for submitted note */}
            {licenseData.Status === "Submitted" && (
              <div className="bg-gradient-to-r from-blue-600 to-blue-700">
                <strong className="text-white mt-1">
                  Submitted Note :
                </strong>
                <span className="text-white mt-1">
                  {licenseData.Status ? licenseData.submitNote : "N/A"}
                </span>
              </div>
            )}
            {/* for completed note */}
            {licenseData.Status === "Completed" && (
              <div className="bg-gradient-to-r from-blue-600 to-blue-700">
                <strong className="text-white mt-1">
                  completed Note:
                </strong>
                <span className="text-white mt-1">
                  {licenseData.Status ? licenseData.completedNote : "N/A"}
                </span>
              </div>
            )}
          </div>
          <DownloadableDocuments />
          {/* Conditionally render based on Kissan Point Type */}
          <form onSubmit={handleUpdate} className="p-6">
            {licenseData.kisanpointtype === "Digital 7 / 12" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InputField
                  label="Full Name"
                  name="fullName"
                  value={licenseData.fullName}
                />
                <InputField
                  label="Application Name"
                  name="application_type"
                  value={licenseData.application_type}
                />
                <InputField
                  label="Kissan Point Type"
                  name="kisanpointtype"
                  value={licenseData.kisanpointtype}
                />
                <InputField
                  label="Email"
                  name="email"
                  value={licenseData.email}
                  type="email"
                />
                <InputField
                  label="Mobile Number"
                  name="mobileNumber"
                  value={licenseData.mobileNumber}
                />
                <InputField
                  label="Village"
                  name="village"
                  value={licenseData.village}
                />
                <InputField
                  label="Tehsil"
                  name="tehsil"
                  value={licenseData.tehsil}
                />
                <InputField
                  label="Gat Number"
                  name="gatNumber"
                  value={licenseData.gatNumber}
                />
              </div>
            )}

            {licenseData.kisanpointtype === "8 अ उत्तरा" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InputField
                  label="Full Name"
                  name="fullName"
                  value={licenseData.fullName}
                />
                <InputField
                  label="Application Name"
                  name="application_type"
                  value={licenseData.application_type}
                />
                <InputField
                  label="Kissan Point Type"
                  name="kisanpointtype"
                  value={licenseData.kisanpointtype}
                />
                <InputField
                  label="Email"
                  name="email"
                  value={licenseData.email}
                  type="email"
                />
                <InputField
                  label="Mobile Number"
                  name="mobileNumber"
                  value={licenseData.mobileNumber}
                />
                <InputField
                  label="Village"
                  name="village"
                  value={licenseData.village}
                />
                <InputField
                  label="Tehsil"
                  name="tehsil"
                  value={licenseData.tehsil}
                />
                <InputField
                  label="District"
                  name="district"
                  value={licenseData.district}
                />
                <InputField
                  label="Khata Number"
                  name="khatanumber"
                  value={licenseData.khatanumber}
                />
              </div>
            )}

            {licenseData.kisanpointtype === "पिक विमा" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InputField
                  label="Full Name"
                  name="fullName"
                  value={licenseData.fullName}
                />
                <InputField
                  label="Application Name"
                  name="application_type"
                  value={licenseData.application_type}
                />
                <InputField
                  label="Kissan Point Type"
                  name="kisanpointtype"
                  value={licenseData.kisanpointtype}
                />
                <InputField
                  label="Email"
                  name="email"
                  value={licenseData.email}
                  type="email"
                />
                <InputField
                  label="Address"
                  name="address"
                  value={licenseData.address}
                />
                <InputField
                  label="Mobile Number"
                  name="mobileNumber"
                  value={licenseData.mobileNumber}
                />
                <InputField
                  label="Date of Birth"
                  name="dateOfBirth"
                  value={licenseData.dateOfBirth}
                />
                <InputField
                  label="Pincode"
                  name="pincode"
                  value={licenseData.pincode}
                />
              </div>
            )}
            {licenseData.kisanpointtype === "Fair Far" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InputField
                  label="Full Name"
                  name="fullName"
                  value={licenseData.fullName}
                />
                <InputField
                  label="Application Name"
                  name="application_type"
                  value={licenseData.application_type}
                />
                <InputField
                  label="Kissan Point Type"
                  name="kisanpointtype"
                  value={licenseData.kisanpointtype}
                />
                <InputField
                  label="Email"
                  name="email"
                  value={licenseData.email}
                  type="email"
                />
                <InputField
                  label="Address"
                  name="address"
                  value={licenseData.address}
                />
                <InputField
                  label="Mobile Number"
                  name="mobileNumber"
                  value={licenseData.mobileNumber}
                />
                <InputField
                  label="Date of Birth"
                  name="dateOfBirth"
                  value={licenseData.dateOfBirth}
                />
                <InputField
                  label="Pincode"
                  name="pincode"
                  value={licenseData.pincode}
                />
              </div>
            )}
            {licenseData.kisanpointtype === "PM Kisan Nidhi Yojana" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InputField
                  label="Full Name"
                  name="fullName"
                  value={licenseData.fullName}
                />
                <InputField
                  label="Application Name"
                  name="application_type"
                  value={licenseData.application_type}
                />
                <InputField
                  label="Kissan Point Type"
                  name="kisanpointtype"
                  value={licenseData.kisanpointtype}
                />
                <InputField
                  label="Email"
                  name="email"
                  value={licenseData.email}
                  type="email"
                />
                <InputField
                  label="Address"
                  name="address"
                  value={licenseData.address}
                />
                <InputField
                  label="Mobile Number"
                  name="mobileNumber"
                  value={licenseData.mobileNumber}
                />
                <InputField
                  label="Date of Birth"
                  name="dateOfBirth"
                  value={licenseData.dateOfBirth}
                />
                <InputField
                  label="Pincode"
                  name="pincode"
                  value={licenseData.pincode}
                />
              </div>
            )}
      <div>
              {/* Application History */}
              <div className="bg-green-50 shadow-md p-6 rounded-lg w-full lg:w-full space-y-4">
                <h2 className="text-xl text-center font-bold mb-4 text-gray-700 border-b-2 border-gray-400 pb-2">
                  Application History
                </h2>

                <div className="flex justify-between text-gray-800">
                  <strong className="text-gray-600 flex-1">Created At (Date & Time):</strong>
                  <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                    {new Date(licenseData.createdAt).toLocaleString('en-IN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                      hour12: true,
                    })}
                  </span>
                </div>

                <div className="flex justify-between text-gray-800">
                  <strong className="text-gray-600 flex-1">Updated At (Date & Time):</strong>
                  <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                    {licenseData.updatedAt
                      ? new Date(licenseData.updatedAt).toLocaleString('en-IN', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: true,
                      })
                      : 'N/A'}
                  </span>
                </div>

                <div className="flex justify-between text-gray-800">
                  <strong className="text-gray-600 flex-1">Current Status:</strong>
                  <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                    {licenseData.Status ? licenseData.Status : 'N/A'}
                  </span>
                </div>

                {/* for display note accroding to status  */}
                {licenseData.Status === "Rejected" && (
                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Rejected Note:
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.Status ? licenseData.rejectedNote : "N/A"}
                    </span>
                  </div>
                )}

                {/* history */}
                {/* Display history regardless of Status */}
                <div className="flex justify-between text-gray-800">
                  <div className="text-gray-600 flex-1">
                    <strong className="text-gray-600">Status History:</strong>
                  </div>

                  {/* Display for new schema with statusHistory */}
                  {licenseData.statusHistory && licenseData.statusHistory.length > 0 ? (
                    <div className="flex-1 text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.statusHistory.map((statusChange, index) => (
                        <div
                          key={index}
                          className={`p-3 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border-b border-gray-300 last:border-b-0`}
                        >
                          <div className="flex justify-between items-center mb-1">
                            <span className="text-sm font-medium text-gray-500">
                              Changed on: {new Date(statusChange.changedAt).toLocaleString()}
                            </span>
                            <span className={`text-xs font-semibold px-2 py-1 rounded ${statusChange.status === 'Rejected' ? 'bg-red-100 text-red-800' :
                              statusChange.status === 'Submitted' ? 'bg-blue-100 text-blue-800' :
                                statusChange.status === 'Completed' ? 'bg-green-100 text-green-800' :
                                  'bg-yellow-100 text-yellow-800'
                              }`}>
                              {statusChange.status}
                            </span>
                          </div>
                          <p className="text-gray-700">{statusChange.note || "No additional notes"}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    // Fallback for when no status history exists
                    <div className="text-center text-gray-500 border border-gray-300 bg-gray-50 p-3 rounded">
                      No status history available
                    </div>
                  )}
                </div>
              </div>

            </div>

            {isEditable && (
              <div className="mt-8 space-y-4">
                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-medium
                    shadow-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-500 focus:ring-opacity-50
                    transform transition-all duration-150 hover:scale-[1.02]"
                >
                  Update Form
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
      <CustomToastContainer />
      <DocumentPreviewModal
        document={showDocument}
        onClose={() => setShowDocument(null)}
      />
    </div>
  );
};

export default User_common;
